module.exports = "./img/6ce7fbf8de1a9871a8745da94024968c.jpg";